<template>
    <div class="homepage" @touchmove.prevent>
    <!-- <div class="homepage"> -->
         <!-- 主场景 -->
        <div class="homepage__container"
            :class="{ starting }"
            :style="`transform:translate(${roll}%,0)`">
            <!-- 人 -->
            <img src="http://cdn.shikehuyu.com/card/homepage-people.png?v=1.0.5" class="homepage__container__people"
                :style="peopleTransform">
            <!-- 指纹 -->
            <div class="homepage__container__fingerprint__cnt"
                :style="peopleTransform + fingerPrintPosition">
                <img src="http://cdn.shikehuyu.com/card/homepage-fingerprint.png?v=1.0.0" class="homepage__container__fingerprint">
                <img src="http://cdn.shikehuyu.com/card/homepage-fingerprint2.png?v=1.0.0" class="homepage__container__fingerprint2 bling2">
            </div>
            <!-- 背景 -->
            <img src="http://cdn.shikehuyu.com/card/homepage-BG.png?v=1.0.0" class="homepage__container__bg">
            <!-- 装饰物 -->
            <div class="homepage__container__decorate"
                :style="peopleTransform">
                <!-- 几何体 -->
                <img src="http://cdn.shikehuyu.com/card/homepage-geometry1.png?v=1.0.1" class="homepage__container__decorate__geometry1 wanderVer">
                <img src="http://cdn.shikehuyu.com/card/homepage-geometry2.png?v=1.0.1" class="homepage__container__decorate__geometry2 wanderVer">
                <img src="http://cdn.shikehuyu.com/card/homepage-geometry3.png?v=1.0.1" class="homepage__container__decorate__geometry3 wanderVer">
                <img src="http://cdn.shikehuyu.com/card/homepage-geometry3.png?v=1.0.1" class="homepage__container__decorate__geometry4 wanderVer">
                <img src="http://cdn.shikehuyu.com/card/homepage-geometry5.png?v=1.0.1" class="homepage__container__decorate__geometry5 wanderVer">
                <img src="http://cdn.shikehuyu.com/card/homepage-geometry6.png?v=1.0.0" class="homepage__container__decorate__geometry6 wanderVer">
                <img src="http://cdn.shikehuyu.com/card/homepage-geometry7.png?v=1.0.0" class="homepage__container__decorate__geometry7 wanderVer">
                <img src="http://cdn.shikehuyu.com/card/homepage-geometry7.png?v=1.0.0" class="homepage__container__decorate__geometry8 wanderVer">
                <img src="http://cdn.shikehuyu.com/card/homepage-geometry7.png?v=1.0.0" class="homepage__container__decorate__geometry9 wanderVer">
                <!-- 线 -->
                <img src="http://cdn.shikehuyu.com/card/homepage-line1.png?v=1.0.0" class="homepage__container__decorate__line1 bling">
                <img src="http://cdn.shikehuyu.com/card/homepage-line1.png?v=1.0.0" class="homepage__container__decorate__line2 bling2">
                <img src="http://cdn.shikehuyu.com/card/homepage-line1.png?v=1.0.0" class="homepage__container__decorate__line3 bling">
                <img src="http://cdn.shikehuyu.com/card/homepage-line1.png?v=1.0.0" class="homepage__container__decorate__line4 bling">
                <img src="http://cdn.shikehuyu.com/card/homepage-line1.png?v=1.0.0" class="homepage__container__decorate__line5 bling">
                <img src="http://cdn.shikehuyu.com/card/homepage-line1.png?v=1.0.0" class="homepage__container__decorate__line6 bling2">
                <img src="http://cdn.shikehuyu.com/card/homepage-line1.png?v=1.0.0" class="homepage__container__decorate__line7 bling2">
                <img src="http://cdn.shikehuyu.com/card/homepage-line1.png?v=1.0.0" class="homepage__container__decorate__line8 bling2">
                <img src="http://cdn.shikehuyu.com/card/homepage-line1.png?v=1.0.0" class="homepage__container__decorate__line9 bling">
                <img src="http://cdn.shikehuyu.com/card/homepage-line1.png?v=1.0.0" class="homepage__container__decorate__line10 bling2">
                <img src="http://cdn.shikehuyu.com/card/homepage-line1.png?v=1.0.0" class="homepage__container__decorate__line11 bling2">
                <img src="http://cdn.shikehuyu.com/card/homepage-line1.png?v=1.0.0" class="homepage__container__decorate__line12 bling">
                <img src="http://cdn.shikehuyu.com/card/homepage-line1.png?v=1.0.0" class="homepage__container__decorate__line13 bling2">
                <img src="http://cdn.shikehuyu.com/card/homepage-line1.png?v=1.0.0" class="homepage__container__decorate__line14 bling2">
            </div>
        </div>
        <div>
            <img src="http://cdn.shikehuyu.com/card/homepage-clickhand.png?v=1.0.0" class="homepage__clickhand bling" v-show="showClickhand"
                @touchstart.prevent="QA1" v-if="clickhand"
                :style="clickHandPosition">
            <img src="http://cdn.shikehuyu.com/card/homepage-hand1.png?v=1.0.0" class="homepage__hand1" @touchstart.prevent="QA1"
                :class="{ raiseHand: hand1, putDownHand: !hand1 && QA === 1 }">
        </div>
        <div>
            <img src="http://cdn.shikehuyu.com/card/homepage-hand3.png?v=1.0.0" class="homepage__hand2" @touchstart.prevent="QA2"
                :class="{ raiseHand: hand2, putDownHand: !hand2 && QA === 2 }">
        </div>
        <div>
            <img src="http://cdn.shikehuyu.com/card/homepage-hand2.png?v=1.0.0" class="homepage__hand3" @touchstart.prevent="QA3"
                :class="{ raiseHand: hand3, putDownHand: !hand3 && QA === 3 }">
        </div>
        <!-- 问答 -->
        <transition name="fade">
            <div class="homepage__QandA" v-show="showQandA">
                <div class="homepage__QandA__box">
                    <img src="http://cdn.shikehuyu.com/card/form-close.png?v=1.0.0" class="homepage__QandA__close" @touchstart="closeQA">
                    <!-- 音乐 -->
                    <img :src="qaMusicIcon" class="homepage__QandA__music"
                        @click="switchQaMusic">
                    <!-- 问答内容 -->
                    <img :src="imgUrl" class="homepage__QandA__main">
                </div>
                <!-- 关闭 -->
            </div>
        </transition>
        <div class="homepage__fingerprint" v-if="fingerprint"
            @click="toGame"></div>
    </div>
</template>

<script>
export default {
    data() {
        const sceneWidth = 5996 / 1334 * window.innerHeight;
        const deltaRoll = (window.innerHeight / (603 / 375) - 375) / 2 / sceneWidth * 100;
        let scaleY = 603 / window.innerHeight;
        scaleY = scaleY > 1 ? 1 : scaleY;
        return {
            scaleY,
            deltaRoll,
            showQandA: false,
            showClickhand: false,
            clickhand: true, // 是否移除点击提示
            // 平移距离 亚马逊-22.1 广发-37.44 万事达-54.5 指纹-84.6 单位%
            // roll: 0,
            roll: -37.44 * scaleY,
            hand1: false,
            hand2: false,
            hand3: false,
            img: 'qaGF',
            QA: 0,
            fingerprint: false,
            qaMusicOn: true,
            showfingerprint: true,
            starting: true,
            positions: {
                gf: -37.44 * scaleY,
                wsd: -54.5 * scaleY,
                ymx: -22.1 * scaleY,
                fingerprint: -84.6 * scaleY,
            }
        };
    },
    computed: {
        imgUrl() {
            return `http://cdn.shikehuyu.com/card/homepage-${this.img}.png?v=1.0.0`;
        },
        qaMusicIcon() {
            return `http://cdn.shikehuyu.com/card/homepage-music${this.qaMusicOn ? '' : '-off'}.png?v=1.0.0`;
        },
        peopleTransform() {
            return `transform: scale(${this.scaleY});`;
        },
        fingerPrintPosition() {
            return `bottom: ${49.3 * this.scaleY}%;left: ${90.1 * this.scaleY}%;width: ${3.1 * this.scaleY}%;`;
        },
        clickHandPosition() {
            return `bottom: ${25 * this.scaleY}vh;`;
        }
    },

    methods: {
        switchQaMusic() {
            this.qaMusicOn = !this.qaMusicOn;
            if (this.qaMusicOn) {
                this.$bus.musicFadeIn(this.currentMusic);
            } else {
                this.$bus.musicFadeOut(this.currentMusic);
            }
        },
        QA1() {
            this.showQandA = true;
            this.showClickhand = false;
            this.clickhand = false;
            this.hand1 = false;
            this.img = 'qaGF';
            this.QA = 1;
            if (this.$bus.musicOn) this.$bus.musicFadeOut('bg', 0.5, 0);
            this.currentMusic = 'q1';
            this.$bus.playMusic('q1');
            if (this.qaMusicOn) {
                this.$bus.musicFadeIn('q1');
            } else {
                this.$bus.musicFadeIn('q1', 0, 0);
            }
        },
        QA2() {
            this.showQandA = true;
            this.hand2 = false;
            this.img = 'qaYMX';
            this.QA = 2;
            if (this.$bus.musicOn) this.$bus.musicFadeOut('bg', 0.5, 0);
            this.currentMusic = 'q2';
            this.$bus.playMusic('q2');
            if (this.qaMusicOn) {
                this.$bus.musicFadeIn('q2');
            } else {
                this.$bus.musicFadeIn('q2', 0, 0);
            }
        },
        QA3() {
            this.showQandA = true;
            this.hand3 = false;
            this.img = 'qaWSD';
            this.QA = 3;
            if (this.$bus.musicOn) this.$bus.musicFadeOut('bg', 0.5, 0);
            this.currentMusic = 'q3';
            this.$bus.playMusic('q3');
            if (this.qaMusicOn) {
                this.$bus.musicFadeIn('q3');
            } else {
                this.$bus.musicFadeIn('q3', 0, 0);
            }
        },
        closeQA() {
            if (this.QA === 1) {
                // 广发
                if (this.qaMusicOn) this.$bus.musicFadeOut(this.currentMusic);
                if (this.$bus.musicOn) this.$bus.musicFadeIn('bg', 0, 0.5);
                this.showQandA = false;
                setTimeout(() => {
                    this.QA = 2;
                    this.hand2 = true;
                    this.roll = this.positions.ymx;
                }, 300);
            } else if (this.QA === 2) {
                // 亚马逊
                if (this.qaMusicOn) this.$bus.musicFadeOut(this.currentMusic);
                if (this.$bus.musicOn) this.$bus.musicFadeIn('bg', 0, 0.50);
                this.showQandA = false;
                this.hand2 = false;
                setTimeout(() => {
                    this.QA = 3;
                    this.hand3 = true;
                    this.roll = this.positions.wsd;
                }, 300);
            } else if (this.QA === 3) {
                // 万事达
                if (this.qaMusicOn) this.$bus.musicFadeOut(this.currentMusic);
                if (this.$bus.musicOn) this.$bus.musicFadeIn('bg', 0, 0.5);
                this.showQandA = false;
                this.QA = 4;
                setTimeout(() => {
                    this.roll = this.positions.fingerprint;
                }, 300);
                setTimeout(() => {
                    this.fingerprint = true;
                }, 500);
            }
        },
        toGame() {
            this.$bus.playMusic('out');
            this.$router.replace('game');
        },
        clearCountdown() {
            clearTimeout(this.countdownTimeout);
        },
        initAudios() {
            if (!this.$bus.musicLoaded) {
                this.$bus.loadMusic();
            }
            this.$bus.audios.q1.once('end', () => {
                if (this.QA === 1) {
                    this.currentMusic = 'gf';
                    this.$bus.playMusic('gf');
                }
            });
            this.$bus.audios.q2.once('end', () => {
                if (this.QA === 2) {
                    this.currentMusic = 'ymx';
                    this.$bus.playMusic('ymx');
                }
            });
            this.$bus.audios.q3.once('end', () => {
                if (this.QA === 3) {
                    this.currentMusic = 'wsd';
                    this.$bus.playMusic('wsd');
                }
            });
        },
        // 开场动画
        startAni() {
            setTimeout(() => {
                this.$bus.playMusic('start');
                setTimeout(() => {
                    this.roll = this.positions.wsd;
                    setTimeout(() => {
                        this.roll = this.positions.ymx;
                        setTimeout(() => {
                            this.roll = this.positions.gf;
                            setTimeout(() => {
                                this.starting = false;
                                this.QA = 1;
                                this.hand1 = true;
                            }, 1500);
                        }, 2500);
                    }, 2500);
                }, 2500);
            }, 300);
        },
        // 注册动画回调
        initAni() {
            const animationCallback = () => {
                this.showClickhand = true;
                document.getElementsByClassName('homepage__hand1')[0]
                    .removeEventListener('animationend', animationCallback);
            };
            document.getElementsByClassName('homepage__hand1')[0]
                .addEventListener('animationend', animationCallback);
        }
    },
    mounted() {
        // 初始化音频事件
        this.initAudios();
        // 开场动画
        this.startAni();
        // 动画回调
        this.initAni();
        window.homepage = this;
    }
};
</script>

<style lang="scss">
@import '../style/mixin.scss';
@import '../style/color.scss';
@import '../style/animation.scss';
.homepage {
    @include fullscreen;
    overflow: hidden;
    &__hand1 {
        width: 26.1vw;
        position: absolute;
        bottom: 0;
        left: 0;
        transform: translate(0, 100%);
    }
    &__hand2 {
        width: 23.3vw;
        position: absolute;
        bottom: 0;
        left: 0;
        transform: translate(0,100%);
    }
    &__hand3 {
        width: 31.7vw;
        position: absolute;
        bottom: 0;
        left: 0;
        transform: translate(0,100%);
    }
    &__clickhand {
        position: absolute;
        left: 2vw;
        bottom: 25vh;
        width: 27.7vw;
        z-index: 1;
    }
    &__container {
        transition: transform 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
        transform: translate(-20%,0);
        position: absolute;
        top: 0;
        left: 0;
        &.starting {
            transition: transform 1s cubic-bezier(0.165, 0.84, 0.44, 1);
        }
        &__fingerprint__cnt {
            position: absolute;
            bottom: 49.3%;
            left: 90.1%;
            width: 3.1%;
            z-index: 6;
        }
        &__fingerprint {
            width: 100%;
            position: relative;
            z-index: 6;
            user-select: none;
        }
        &__fingerprint2 {
            @include transform-center;
            width: 100%;
            z-index: 7;
            user-select: none;
        }
        // &__fingerprint {
        //     position: absolute;
        //     top: 35.3%;
        //     left: 90.1%;
        //     width: 3.1%;
        //     z-index: 6;
        //     user-select: none;
        // }
        // &__fingerprint2 {
        //     position: absolute;
        //     top: 35.3%;
        //     left: 90.1%;
        //     width: 3.1%;
        //     z-index: 7;
        //     user-select: none;
        // }
        &__bg {
            height: 100vh;
            z-index: 1;
            display: block;
        }
        &__people {
            position: absolute;
            left: 0;
            height: 100vh;
            z-index: 3;
            bottom: 0;
            transform-origin: left bottom;
        }
        &__decorate {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            bottom: 0;
            transform-origin: left bottom;
            z-index: 2;
            &__geometry1 {
                width: 20vw;
                position: absolute;
                top: 33.1%;
                left: 36.2%;
            }
            &__geometry2 {
                width: 45.7vw;
                position: absolute;
                bottom: -10%;
                right: 10.1%;
            }
            &__geometry3 {
                width: 45.7vw;
                position: absolute;
                top: 0;
                right: 38.5;
            }
            &__geometry4 {
                width: 109.6vw;
                position: absolute;
                top: -51%;
                right: 23.4%;
            }
            &__geometry5 {
                width: 111vw;
                position: absolute;
                top: 0;
                left: 15%;
                mix-blend-mode: lighten;
            }
            &__geometry6 {
                width: 157.2vw;
                position: absolute;
                bottom: 0;
                right: 21%;
            }
            &__geometry7 {
                width: 39.6vw;
                position: absolute;
                top: 33.6%;
                left: 11%;
            }
            &__geometry8 {
                width: 39.6vw;
                position: absolute;
                bottom: 21%;
                left: 31.4%;
            }
            &__geometry9 {
                width: 39.6vw;
                position: absolute;
                bottom: 3%;
                right: 1.8%;
            }
            &__line1 {
                position: absolute;
                width: 28.9vw;
                left: 12.4%;
                top: 8.8%;
            }
            &__line2 {
                position: absolute;
                width: 9.8vw;
                left: 9%;
                top: 57.8%;
            }
            &__line3 {
                position: absolute;
                width: 21.7vw;
                left: 26.8%;
                top: 66.1%;
            }
            &__line4 {
                position: absolute;
                width: 10.5vw;
                left: 30%;
                top: 20%;
            }
            &__line5 {
                position: absolute;
                width: 28.9vw;
                left: 35.2%;
                top: 48.8%;
            }
            &__line6 {
                position: absolute;
                width: 28.9vw;
                left: 29.6%;
                top: -10%;
            }
            &__line7 {
                position: absolute;
                width: 28.9vw;
                left: 45.5%;
                top: -10%;
            }
            &__line8 {
                position: absolute;
                width: 10.5vw;
                left: 45.5%;
                top: 26.8%;
            }
            &__line9 {
                position: absolute;
                width: 10.5vw;
                left: 35.2%;
                top: 8.8%;
            }
            &__line10 {
                position: absolute;
                width: 10.5vw;
                left: 70.4%;
                top: 12.2%;
            }
            &__line11 {
                position: absolute;
                width: 17.8vw;
                left: 48.4%;
                top: 54.4%;
            }
            &__line12 {
                position: absolute;
                width: 10.5vw;
                right: 1.3%;
                top: 29.8;
            }
            &__line13 {
                position: absolute;
                width: 28.9vw;
                bottom: 13.4%;
                right: -1.5%;
            }
            &__line14 {
                position: absolute;
                width: 28.9vw;
                top: 8.8%;
                right: 33.55%;
            }
        }
    }
    &__QandA {
        @include fullscreen;
        @include box;
        background-color: rgba(0, 0, 0, 0.7);
        &__box {
            position: relative;
        }
        &__close {
            width: 10vw;
            position: absolute;
            top: 0;
            right: 0;
            transform: translate(40%, -40%);
            z-index: 5;
        }
        &__music {
            width:3.6%;
            position: absolute;
            top: 5%;
            right: 5%;
            padding: 5%;
            z-index: 5;
        }
        &__main {
            width: 80.1vw;
            @include bg-cover;
        }
    }
    &__fingerprint {
        position: absolute;
        width: 100vw;
        height: 100vh;
        top: 0;
        right: 0;
    }
}
//举手
.raiseHand {
    animation-name: raiseHand;
    animation-duration: 1.5s;
    animation-fill-mode: forwards;
}

@keyframes raiseHand {
    from {
        transform: translate(0,100%);
    }
    to {
       transform: translate(0,0);
    }
}

//放下手
.putDownHand {
    animation-name: putDownHand;
    animation-duration: 1.5s;
    animation-fill-mode: forwards;
}
@keyframes putDownHand {
    from {
        transform: translate(0, 0);
    }
    to {
        transform: translate(0,100%);
    }
}
</style>




// WEBPACK FOOTER //
// src/components/homepage.vue